module.exports = __webpack_public_path__ + "f81322b1d500200a123af253126653f8.jpg";